var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._l((_vm.headers),function(header,index){return _c('td',{key:index},[_vm._t(_vm.columnName(header),[_c('div',[_vm._v("\n        "+_vm._s(_vm.getNonSlotValue(_vm.item, header))+"\n      ")])],{"item":_vm.item})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }